var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-10 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-fab",
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_c("md-icon", [_vm._v("arrow_back")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-80 md-medium-size-80 md-small-size-80 md-xsmall-size-100"
        },
        [
          _vm.loading
            ? _c("div", { staticClass: "loading" }, [
                _c(
                  "div",
                  {
                    staticClass: "md-layout md-gutter md-alignment-top-center"
                  },
                  [
                    _c("md-progress-spinner", {
                      attrs: {
                        "md-diameter": 50,
                        "md-stroke": 5,
                        "md-mode": "indeterminate"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.searchresults, function(item) {
            return _c(
              "div",
              { key: item.name },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "no-link",
                    attrs: {
                      to: {
                        name: "BusinessModelDetail",
                        params: { hash: item.hash }
                      }
                    }
                  },
                  [
                    _c(
                      "md-card",
                      {
                        staticClass:
                          "margin-twenty md-alignment-top-center md-elevation-1",
                        attrs: { "md-with-hover": "" }
                      },
                      [
                        _c("md-card-header", { staticClass: "md-title" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.name) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("md-card-content", {
                          domProps: {
                            innerHTML: _vm._s(_vm.shorten(item.description))
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-10 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-da0b34d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da0b34d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/businessmodelsearch/query/BusinessModelSearch.vue
// module id = null
// module chunks = 